module.exports = __webpack_public_path__ + "static/media/checked.9f02988d.svg";